export const isEqual = (a: any, b: any): boolean => {
    if (a === b) return true;
    if (a == null || b == null) return false;
    if (typeof a !== 'object' || typeof b !== 'object') return false;

    const keysA = Object.keys(a);
    const keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;

    for (const key of keysA) {
        if (!keysB.includes(key)) return false;
        if (!isEqual(a[key], b[key])) return false;
    }
    return true;
};

export const getChangedPaths = (oldObj: any, newObj: any, prefix = ''): string[] => {
    const paths: string[] = [];

    const allKeys = new Set([...Object.keys(oldObj || {}), ...Object.keys(newObj || {})]);

    for (const key of allKeys) {
        const oldVal = oldObj?.[key];
        const newVal = newObj?.[key];
        const fullPath = prefix ? `${prefix}.${key}` : key;

        if (!isEqual(oldVal, newVal)) {
            if (typeof newVal === 'object' && newVal !== null && !Array.isArray(newVal) &&
                typeof oldVal === 'object' && oldVal !== null && !Array.isArray(oldVal)) {
                paths.push(...getChangedPaths(oldVal, newVal, fullPath));
            } else {
                paths.push(fullPath);
            }
        }
    }

    return paths;
};
